import { ROUTES } from "src/constants";

export const getRaPathWithChallangeFilter = (name: string | null) => {
  const base = `/${ROUTES.USER}/${ROUTES.SCAN_HISTORY}`;

  if (!name) {
    return base;
  }

  const params = new URLSearchParams({ challenges: name, open: 'true' });

  return `${base}?${params.toString()}`;
}
